export default __webpack_public_path__ + "static/media/trinityHero.1408bc7f.webp";